import React from "react";

const ESTADO_CONFIG = {
    en_tiempo: { label: "EN TIEMPO", color: "#16A34A", bg: "#F0FDF4", border: "#16A34A" },
    atrasado: { label: "ATRASADO", color: "#DC2626", bg: "#FEF2F2", border: "#DC2626" },
    sin_iniciar: { label: "SIN INICIAR", color: "#71717A", bg: "#FAFAFA", border: "#D4D4D8" },
    finalizado: { label: "FINALIZADO", color: "#2563EB", bg: "#EFF6FF", border: "#2563EB" },
};

/**
 * Badge de estado de cronograma. Espera el objeto "cronograma" que devuelve el backend:
 * { estado, pct_tiempo_transcurrido, pct_avance_real, dias_transcurridos, dias_totales, dias_atraso_estimados }
 */
export default function CronogramaBadge({ cronograma, showDetail }) {
    if (!cronograma) return null;
    const cfg = ESTADO_CONFIG[cronograma.estado] || ESTADO_CONFIG.sin_iniciar;
    return (
        <div data-testid="cronograma-badge">
            <span
                className="text-[10px] font-mono font-bold px-2 py-0.5 border inline-block"
                style={{ color: cfg.color, background: cfg.bg, borderColor: cfg.border }}
            >
                {cfg.label}
                {cronograma.estado === "atrasado" && cronograma.dias_atraso_estimados > 0 && ` · ~${cronograma.dias_atraso_estimados}d`}
            </span>
            {showDetail && (
                <div className="text-[11px] text-zinc-500 mt-1 font-mono">
                    Tiempo transcurrido: {cronograma.pct_tiempo_transcurrido}% · Avance real: {cronograma.pct_avance_real}%
                </div>
            )}
        </div>
    );
}
